
<div style="display:block; width:100%;">
  <div class="row no-gutters">

    <div class="mr-1" style="flex: 0 0 70px; max-width: 70px;">
      <input [id]="input.MainElementList[0].ID" type="text" class="col q-input-border q-bo"
             [disabled]="input.MainElementList[0].Disabled"
             [(ngModel)]="input.MainElementList[0].Value"
             [ngClass]="setClass(input, 0)"
             (keyup)="searchCP()"
             (focus)="showListCity = false">

      <!-- list element with search results CP -->
      <div class="listResult" *ngIf="showListCP">
        <cdk-virtual-scroll-viewport [style.height]="listCP | calculHeight" itemSize="25">
          <ul class="list-unstyled">

            <ng-container *cdkVirtualFor="let cp of listCP">
              <li (click)="selectCP(cp.Text)">
                <span>{{cp.Text}}</span>
              </li>
            </ng-container>
          </ul>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
    <div class="col">
      <input [id]="input.MainElementList[1].ID" type="text" class="col q-input-border q-bo"
             [disabled]="input.MainElementList[1].Disabled"
             [(ngModel)]="input.MainElementList[1].Value"
             [ngClass]="setClass(input, 1)"
             (keyup)="searchCity()"
             (focus)="showListCP = false">

      <!-- list element with search results Ville -->
      <div class="listResult" *ngIf="showListCity">
        <cdk-virtual-scroll-viewport [style.height]="listCity | calculHeight" itemSize="25">
          <ul class="list-unstyled">
            <ng-container *cdkVirtualFor="let city of listCity">
              <li (click)="selectCity(city.Text)">
                <span>{{city.Text}}</span>
              </li>
            </ng-container>
          </ul>
        </cdk-virtual-scroll-viewport>
      </div>
    </div>
    <ng-container *ngFor="let button of input?.MainElementList?.slice(2)">
      <button *ngIf="button.Type === 'BUTTON'" class="q-btn q-bo q-main p-0" (click)="onClickButton(button);"
              [title]="button?.Tooltip ? button?.Tooltip : ''">
        <i class="{{button.Src}}"></i>
      </button>
    </ng-container>
  </div>
</div>
